export default {
  bankTransfer: 'Transferencia Bancaria',
  firstTitle: 'Por favor, seleccione la moneda de remesa',
  secondTitle: 'Después de la transferencia',
  bankTips:
    'Obtenga la información del beneficiario y vaya al puesto de trabajo del banco correspondiente para llenar el giro. Por favor, revise su ortografía detenidamente.',
  receiverTitle: 'Información del Beneficiario',
  bankAttrEnum: {
    0: 'Número de cuenta',
    1: 'Número de ruta',
    2: 'Nombre de la cuenta',
    3: 'Nombre del banco',
    4: 'Dirección del banco',
    5: 'Código postal',
    6: 'País/Región',
    7: 'Tipo de cuenta',
    8: 'Observación'
  },
  transferTips:
    'Puede informarnos de cualquiera de las siguientes maneras y lo verificaremos lo antes posible.',
  transferName: 'Nombre del remitente',
  transferBank: 'Banco del remitente',
  transferNo: 'Número de referencia',
  submit: 'Enviar ahora',
  successSubmit: 'Envío exitoso',
  successSubmitTips:
    '* Si se produce algún problema durante la verificación, nos pondremos en contacto con el correo electrónico de registro de su cuenta en acbuy.',
  tradeDetail: 'Detalle de la transacción',
  backOrder: 'Volver al pedido',
  holder: {
    inputNo: 'Por favor, proporcione el número de referencia si está disponible.'
  },
  transferExplain: 'Instrucciones de transferencia bancaria:',
  transferExplainEnum: {
    0: 'acbuy no cobra comisiones por este canal de pago. Si el banco remitente cobra comisiones depende de las políticas correspondientes del banco.',
    1: 'Este método de pago admite múltiples monedas. Los clientes pueden elegir la cuenta bancaria correspondiente para la remesa según su región y necesidades.',
    2: 'Normalmente, tarda de 1 a 3 días hábiles en llegar; en circunstancias especiales, tarda de 1 a 5 días hábiles en llegar.',
    3: "acbuy convertirá el monto en yuanes al tipo de cambio de acbuy cuando reciba la remesa y luego lo acreditará en su cuenta.",
    4: 'El monto final en yuanes en la cuenta de acbuy = Monto de su remesa * Tipo de cambio de la plataforma acbuy.'
  }
};
